<template>
  <li class="button-container_list_item">
    <input
      :id="id"
      class="day-input"
      type="radio"
      name="day-button"
      @click.self="$emit('moveDayScadule', day)"
    />
    <label class="day-label" :class="getCurrentWeek" :for="id">
      {{ day }}
    </label>
  </li>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },

    year: {
      type: Number,
      required: true,
    },
    month: {
      type: Number,
      required: true,
    },
    day: {
      type: Number,
      required: true,
    },
  },
  computed: {
    getCurrentWeek() {
      const weekNumber = new Date(this.year, this.month - 1, this.day).getDay()
      if (weekNumber === 0) {
        return 'sunday'
      } else if (weekNumber === 6) {
        return 'saturday'
      } else {
        return 'weekday'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sunday {
  background: #ea5550;
  color: #ffffff;
}
.saturday {
  background: #4496d3;
  color: #ffffff;
}
.weekday {
  background: #ffffff;
  color: #4d5c72;
}

.button-container {
  &_list {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    &_item {
      list-style: none;
      margin-right: 10px;
      input[type='radio'] {
        display: none;
        opacity: 0;
        visibility: hidden;
      }
      input[type='radio']:checked + label {
        color: #ffffff;
        background: $main_color;
      }
      label {
        text-align: center;
        box-sizing: border-box;
        font-size: 18px;
        transition: 0.3s all;
        &:hover {
          background: $main_color;
          color: #ffffff;
        }
      }
      .month-label {
        width: 60px;
        padding: 5px 10px;
        border-radius: $radius;
      }
      .day-label {
        width: 24px;
        height: 24px;
        font-size: 16px;
        border-radius: 50%;
      }
      .item-label {
        border-radius: $radius;
        width: 100%;
      }
    }
  }
}
</style>
